import { render, staticRenderFns } from "./EmailConfig.vue?vue&type=template&id=77dd3775&"
import script from "./EmailConfig.vue?vue&type=script&lang=js&"
export * from "./EmailConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports